import React from "react";
import { createTableHeaderCell } from "@whalecloud/page-builder-core/utils/elementUtils";
import TableEdit from "./components/TableEdit";
import TableEditSettings from "./components/TableEditSettings";
import { ReactComponent as PluginSvg } from "@assets/icons/table_edit_setting.svg";
import { getLocale, defaultTarget } from '@utils/util';

const defaultColumns = [
  {
    key: '1',
    title: 'Name',
    dataIndex: 'name',
    width: 150,
    editType: 'text',
  },
  {
    key: '2',
    title: 'Age',
    dataIndex: 'age',
    width: 50,
    editType: 'text',
  },
  {
    key: '3',
    title: 'Sex',
    dataIndex: 'sex',
    width: 50,
    // editType: 'select',
    // editOptions: 'https://mock.iwhalecloud.com/mock/2880/api/options',
  },
  {
    key: '4',
    title: 'Address',
    dataIndex: 'address',
    width: 200,
    editType: 'text',
  }
];

const defaultDataSource = [
  {
    key: '1',
    name: 'Lucy',
    age: 22,
    sex: '01',
    address: 'XXXXX',
  },
  {
    key: '2',
    name: 'Jerry',
    age: 23,
    sex: '02',
    address: 'XXXXX',
  },
  {
    key: '23',
    name: 'Amy',
    age: 32,
    sex: '03',
    address: 'XXXXX',
  },
];

const tarnsformDefaultColumns = defaultColumns.map(item => {
  return {
    columnSettings: {
      ...item
    }
  }
});

const getElements = () => {
  const elements = [];
  tarnsformDefaultColumns.forEach(item => {
    elements.push(createTableHeaderCell({ data: item }));
  });
  return elements;
}

export default () => {
  const messages = getLocale();
  return {
    name: 'tableEdit',
    target: defaultTarget,
    title: messages['PAGEBUIDER_ELEMENT_FORM_TABLEEDIT'], // 插件标题
    toolBarPreview: <PluginSvg />,
    data: {
      tableSettings: {
        autoInitialize: true,
        rowSelection: false,
        insertable: true,
        removeable: true,
        upmoveable: true,
        downmoveable: true,
        dataSource: defaultDataSource,
        operateFirst: false,
      },
      formSettings: {
        label: messages['PAGEBUIDER_ELEMENT_FORM_TABLEEDIT']
      },
      settings: {
        width: {
          value: "100%"
        },
      }
    },
    elements: getElements,
    pluginComponent: TableEdit,
    pluginSettingComponent: TableEditSettings,
  }
}
